// extracted by mini-css-extract-plugin
export var textInput = "_fr-0";